import { useTranslation } from "react-i18next";
import { Text } from "components/text";
import { cn } from "utils";

export const ThemaCodesResultsIndicator = ({
  query,
  totalResults,
  currentResults,
  isLoadingMore,
  hasMorePages,
  isSearching,
  className,
}: {
  query: string;
  totalResults: number;
  currentResults: number;
  isLoadingMore: boolean;
  hasMorePages: boolean;
  isSearching: boolean;
  className?: string;
}) => {
  const { t } = useTranslation(["components"]);

  if (!query.trim()) return null;

  // Show null if we have no accumulated results and the search is complete
  if (totalResults === 0 && currentResults === 0 && !isSearching) {
    return null;
  }

  // Show results footer if we have any results (accumulated or from current query)
  if (totalResults || isLoadingMore) {
    let footerText;
    if (isLoadingMore) {
      footerText = t("components:themaCodes.loadingMore", {
        total: totalResults,
      });
    } else if (hasMorePages) {
      footerText = t("components:themaCodes.showingPartial", {
        current: currentResults,
        total: totalResults,
      });
    } else {
      footerText = t("components:themaCodes.showingAll", {
        current: currentResults,
      });
    }

    return (
      <div
        className={cn("flex justify-center py-3 bg-secondary-25", className)}
      >
        <Text as="span" variant="muted">
          {footerText}
        </Text>
      </div>
    );
  }

  return null;
};
